var Event;
(function (Event) {
    Event["onAbort"] = "onAbort";
    Event["onAfterFetch"] = "onAfterFetch";
    Event["onAfterNavigate"] = "onAfterNavigate";
    Event["onBeforeCancel"] = "onBeforeCancel";
    Event["onBeforeClose"] = "onBeforeClose";
    Event["onBeforeFetch"] = "onBeforeFetch";
    Event["onBeforeSubmit"] = "onBeforeSubmit";
    Event["onBlur"] = "onBlur";
    Event["onCancel"] = "onCancel";
    Event["onCatch"] = "onCatch";
    Event["onChange"] = "onChange";
    Event["onClear"] = "onClear";
    Event["onClick"] = "onClick";
    Event["onClose"] = "onClose";
    Event["onCollapse"] = "onCollapse";
    Event["onContextMenuClick"] = "onContextMenuClick";
    Event["onDoubleClick"] = "onDoubleClick";
    Event["onDynamicContentRender"] = "onDynamicContentRender";
    Event["onEdit"] = "onEdit";
    Event["onFocus"] = "onFocus";
    Event["onKeyDown"] = "onKeyDown";
    Event["onKeyPress"] = "onKeyPress";
    Event["onKeyUp"] = "onKeyUp";
    Event["onMount"] = "onMount";
    Event["onNavigate"] = "onNavigate";
    Event["onNextPage"] = "onNextPage";
    Event["onOpen"] = "onOpen";
    Event["onPrevPage"] = "onPrevPage";
    Event["onRender"] = "onRender";
    Event["onSelect"] = "onSelect";
    Event["onSelectGroup"] = "onSelectGroup";
    Event["onSelectItem"] = "onSelectItem";
    Event["onSort"] = "onSort";
    Event["onSubmit"] = "onSubmit";
    Event["onSuccess"] = "onSuccess";
    Event["onUnmount"] = "onUnmount";
    Event["onUnselectGroup"] = "onUnselectGroup";
    Event["onUnselectItem"] = "onUnselectItem";
    Event["onValidate"] = "onValidate";
})(Event || (Event = {}));
export default Event;
//# sourceMappingURL=event.js.map